import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css";

import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import ToolkitProvider, {
  Search,
} from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
import UtilsFormule from "../../../../../utils/UtilsFormule";
import DataTableBOM from "./DataTableBOM";
import DataTableOperations from "./DataTableOperations";
import DataTableAssemblyComponentsWorkOrder from "./DataTableAssemblyComponentsWorkOrder";
import DataTableAssemblyComponentsDechetsWorkOrder from "./DataTableAssemblyComponentsDechetsWorkOrder";
import uploadAndDownloadService from "../../../../../services/uploadAndDownloadFile";
import { useNavigate } from "react-router-dom";




const DataTableStepsWorkOrder=({listSteps,workOrder})=>{


  function userFormatter(cell, row) {
    return (
      <>
      {row.userExecution.matricule}-{row.userExecution.firstName}{" "}
        {row.userExecution.lastName}
      </>
    );
  }
  function produitFormatter(cell, row) {
    return (
      <>
      {row.product.productCode}-{row.product.barcode}{" "}
        {row.product.name}
      </>
    );
  }

  function typeFormatter(cell, row) {
    if(row.type==="PAUSE"){
      return (
        <>PAUSE : 
        {row.causePause}
        </>
      );
    }else{
      return (
        <>TRAVAIL
        </>
      );
    }
    
  }
  function startDateFormatter(cell, row) {
    return <span>{UtilsFormule.formatDateHours(row.startDate)}</span>;
  }
  function endDateFormatter(cell, row) {
    return <span>{UtilsFormule.formatDateHours(row.endDate)}</span>;
  }
  const columns = [
    {
      dataField: "id",
      text: "Opérateur",
      align: "center",
      formatter: userFormatter,
      headerAlign: "center",
      headerStyle: () => {
        return { width: "25%" };
      },
    },
    {
      dataField: "id",
      text: "Actuel date debut",
      align: "center",
      headerAlign: "center",
      formatter: startDateFormatter,
      headerStyle: () => {
        return { width: "10%" };
      },
    },
    {
      dataField: "id",
      text: "Actuel date fin",
      align: "center",
      headerAlign: "center",
      formatter: endDateFormatter,
      headerStyle: () => {
        return { width: "10%" };
      },
    },
    {
      dataField: "id",
      text: "Produit",
      align: "center",
      formatter: produitFormatter,
      headerAlign: "center",
      headerStyle: () => {
        return { width: "25%" };
      },
    },
    {
      dataField: "quantityProduite",
      text: "Qte",
      align: "center",
      // formatter: produitFormatter,
      headerAlign: "center",
      headerStyle: () => {
        return { width: "10%" };
      },
    },
    {
      dataField: "id",
      text: "Type",
      align: "center",
      formatter: typeFormatter,
      headerAlign: "center",
      headerStyle: () => {
        return { width: "10%" };
      },
    },
    // {
    //   dataField: "index",
    //   text: "Station de travail",
    //   align: "center",
    //   formatter: stationFormatter,

    //   headerAlign: "center",
    //   headerStyle: () => {
    //     return { width: "25%" };
    //   },
    // },
    // {
    //   dataField: "index",
    //   text: "BOM",
    //   align: "center",
    //   formatter: bomFormatter,

    //   headerAlign: "center",
    //   headerStyle: () => {
    //     return { width: "15%" };
    //   },
    // },
    // {
    //   dataField: "index",
    //   text: "Priorité",
    //   align: "center",
    //   headerAlign: "center",
    //   formatter: priorityFormatter,

    //   headerStyle: () => {
    //     return { width: "10%" };
    //   },
    // },
    // {
    //   dataField: "index",
    //   text: "Etat",
    //   align: "center",
    //   formatter: stateFormatter,

    //   headerAlign: "center",
    //   headerStyle: () => {
    //     return { width: "10%" };
    //   },
    // },

   
    // {
    //   dataField: "scheduledDate",
    //   text: "Date limite",
    //   align: "center",
    //   headerAlign: "center",
    //   formatter: scheduledDateFormatter,

    //   headerStyle: () => {
    //     return { width: "10%" };
    //   },
    // },
    // {
    //   dataField: "index",
    //   text: "Voir",
    //   align: "center",
    //   headerAlign: "center",
    //   formatter: buttonListStepsFormatter,

    //   headerStyle: () => {
    //     return { width: "10%" };
    //   },
    // },
    
  ];

  function handleTableChange({ products }) {
    return products;
  }
  const { SearchBar } = Search;
  const MyExportCSV = (props) => {
    const handleClick = () => {
      props.onExport();
    };
    return (
      <div>
        <button className="btn btn-dark" onClick={handleClick}>
          <i class="fas fa-download"></i> Télécharger CSV
        </button>
      </div>
    );
  };
  const pageButtonRenderer = ({
    page,
    active,
    disable,
    title,
    onPageChange,
  }) => {
    const handleClick = (e) => {
      e.preventDefault();
      onPageChange(page);
    };
    const activeStyle = {};
    if (active) {
      activeStyle.backgroundColor = "black";
      activeStyle.color = "white";
    } else {
      activeStyle.backgroundColor = "white";
      activeStyle.color = "black";
    }
    if (typeof page === "string") {
      activeStyle.backgroundColor = "white";
      activeStyle.color = "black";
    }
    return (
      <li className="page-item">
        <button
          className="btn btn-dark"
          onClick={handleClick}
          style={activeStyle}
        >
          {page}
        </button>
      </li>
    );
  };
  const options = {
    pageButtonRenderer,
  };
  function stateFormatter(workOrder) {
    if (workOrder.state === "PENDING") {
      return (
        <span style={{ cursor: "pointer" }} className="badge bg-warning">
          En attente
        </span>
      );
    } else if (workOrder.state === "STARTED") {
      return (
        <span style={{ cursor: "pointer" }} className="badge bg-primary">
          En cours
        </span>
      );
    } else if (workOrder.state === "FINISHED") {
      return (
        <span style={{ cursor: "pointer" }} className="badge bg-success">
          Terminé
        </span>
      );
    }
  }
 
  return (
    <div className="card">
      <div className="card-header">
        <h3 className="card-title">Le bons de travail : {workOrder && workOrder.operationDetails.operation.code } - {workOrder && workOrder.operationDetails.operation.name }</h3>
        <div className="float-right">{workOrder && stateFormatter(workOrder)}</div>
      </div>
      <div className="card-body">
        <ToolkitProvider
          keyField="id"
          data={listSteps}
          columns={columns}
          onTableChange={handleTableChange}
          exportCSV
          search
        >
          {(props) => (
            <div>
              <div className="row ml-0">
                <div>
                  <SearchBar
                    {...props.searchProps}
                    className="custome-search-field"
                    style={{ color: "black" }}
                    placeholder="Chercher"
                  ></SearchBar>
                </div>
                <div className="ml-auto mr-0">
                  <MyExportCSV {...props.csvProps}></MyExportCSV>
                </div>
              </div>
              <div className="row">
                <BootstrapTable
                  {...props.baseProps}
                  pagination={paginationFactory(options)}
                  striped
                  hover
                  condensed
                  // expandRow={expandRow}
                />
              </div>
            </div>
          )}
        </ToolkitProvider>
      </div>
    </div>
  );

}
export default DataTableStepsWorkOrder;
